import { webUsersApi } from "@/apis/apis";
import React, { useMemo, useState } from "react";
import BaseTable from "../BaseTable";
import { columns } from "./Columns";

export default function SalesReportListPage() {
  const [columnConfigs, setColumnConfigs] = useState();
  const shownColumns = useMemo(() => columns(columnConfigs), [columnConfigs]);

  return (
    <>
      <BaseTable
        label="Sales Report List"
        apiURL={webUsersApi}
        columns={shownColumns}
        importData={null}
        enableAdd={false}
        enableEditTable={true}
        allColumns={columns()}
        setColumnConfigs={setColumnConfigs}
      />
    </>
  );
}
